import * as React               from "react";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faCaretUp, faCaretDown} from "@fortawesome/free-solid-svg-icons";
import {fragments}              from "@Common/react/fragments";
import {Effect}                 from "@Common/react/effect";

import "./merge-fields.scss";

import {ComponentLink,
        Link,
        makeChain}      from "@Common/react/cst2";
import {UseState}       from "@Common/react/use-state";
import {Types}          from "@Common/types";


export const MergeFields = ({
    variableData,
    onRecordSelectionRange,
    onSetValue,
    idField,
}:{
    variableData            : Types.Apis.Models.VariableData[],
    onRecordSelectionRange  : () => void,
    onSetValue              : (value:string) => void,
    idField                 : string,
}) => (

    makeChain<JSX.Element>()

    // track if dropdown options are displayed
    .then("isOpen", (_, next:ComponentLink<typeof UseState<boolean>>) => UseState({initValue: false, next}))

    .then("shouldDropdownExpandUp", (_, next:ComponentLink<typeof UseState<boolean>>) => UseState({initValue: false, next}))

    // Scroll listener to determine when there is not enough space to expand the Merge Tag drawer downwards(default)
    .then(({shouldDropdownExpandUp}, next:ComponentLink<typeof fragments>) => fragments(
        next(),
        Effect({
            action: () => {
                const listener = () => {
                    const fieldOptionsFrame = window.document.getElementById("field-options-ui-" + idField);
                    const fieldOptionsBottom = fieldOptionsFrame?.getBoundingClientRect().bottom;
                    const mergeFieldDrawer = window.document.getElementById("merge-field-drawer-" + idField);
                    // Sometimes mergeFieldDrawer isn't rendered yet, so we can't calculate the height of it
                    // There may be a better way than hardcoding 205, but it has eluded me for now
                    // const mergeFieldDrawerHeight = mergeFieldDrawer?.offsetHeight;
                    if (fieldOptionsBottom > window.innerHeight - 150) {
                        shouldDropdownExpandUp.onChange(true);
                    } else {
                        shouldDropdownExpandUp.onChange(false);
                    }
                };
                window.addEventListener("scroll", listener);
                return () => window.removeEventListener("scroll", listener);

            }
        })
    ))

    // render the component
    .then(({isOpen, shouldDropdownExpandUp}) => (
        <div className="merge-fields-33a">
            <div className="merge-fields-button"
                xd-qa-type="button" xd-qa-name="Text Gen Tools Button Variable Data"
                onMouseDown={onRecordSelectionRange}
                onKeyDown={onRecordSelectionRange}
                onClick={() => isOpen.onChange(!isOpen.value)}
            >
                <div className="icon" />
                <p>Variable Data</p>
            </div>
            {isOpen.value && <>
                <div className="drawer-background" onClick={() => isOpen.onChange(false)}/>
                <div className={shouldDropdownExpandUp.value ? "drawer expand-up" : "drawer"}
                    id={"merge-field-drawer-" + idField}
                    onClick={() => isOpen.onChange(false)}
                >
                    {variableData.map(variable => (
                        <button key={variable.id}
                            xd-qa-type="button" xd-qa-name={`Text Gen Tools Drop Down Variable Data Option ${variable.name}`}
                            onClick={() => onSetValue(variable.mergeField)}
                        >{variable.name}</button>
                    ))}
                </div>
            </>}
        </div>
    ))

    .run()

);
